import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';
import { BlendFunction } from 'postprocessing';

export interface ColorDepthEffectProperties extends EffectProperties {
  bits: string;
}

// Create a reusable ColorDepth component that can be used in both preview and world
const ColorDepthComponent = forwardRef<any, { properties: ColorDepthEffectProperties; isPreview?: boolean }>((props, ref) => {
  
  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }
  
  const { bits, blendFunction } = properties;

  // Convert blendFunction string to number if it exists
  const blendFunctionValue = blendFunction ? 
    BlendFunction[blendFunction as keyof typeof BlendFunction] : 
    BlendFunction.NORMAL;

  return (
    <PostProcessing.ColorDepth
      bits={parseInt(bits, 10)}
      blendFunction={blendFunctionValue}
    />
  );
});

export const ColorDepthEffectItem: Effect<ColorDepthEffectProperties> = {
  id: '',
  name: 'Color Depth',
  type: 'effect',
  subtype: 'ColorDepth',
  icon: 'Effect',
  properties: {
    bits: '16',
    blendFunction: 'NORMAL',
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.bits',
      type: 'select',
      label: 'Bits',
      default: '16',
      options: [
        { value: '1', label: '1 Bit' },
        { value: '2', label: '2 Bit' },
        { value: '4', label: '4 Bit' },
        { value: '8', label: '8 Bit' },
        { value: '16', label: '16 Bit' },
      ],
      panel: 'effect',
    },
    {
      key: 'properties.blendFunction',
      type: 'select',
      label: 'Blend Function',
      default: 'NORMAL',
      options: [
        { value: 'NORMAL', label: 'Normal' },
        { value: 'ADD', label: 'Add' },
        { value: 'SUBTRACT', label: 'Subtract' },
        { value: 'MULTIPLY', label: 'Multiply' },
        { value: 'SCREEN', label: 'Screen' },
        { value: 'OVERLAY', label: 'Overlay' },
      ],
      panel: 'effect',
    }
  ],
  render: (properties: ColorDepthEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <ColorDepthComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
}; 